import { render, staticRenderFns } from "./dialogNewsDetail.vue?vue&type=template&id=ca85c3de&scoped=true"
import script from "./dialogNewsDetail.vue?vue&type=script&lang=js"
export * from "./dialogNewsDetail.vue?vue&type=script&lang=js"
import style0 from "./dialogNewsDetail.vue?vue&type=style&index=0&id=ca85c3de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca85c3de",
  null
  
)

export default component.exports